import axios from 'axios';

import { downloadCookieExists, removeDownloadCookie } from './components/download-sample/cookie-cleanup';

export const getPackingSlipTemplates = () => {
  return axios.get('templates/packingslips');
};

export const postPackingSlipTemplate = (newTemplate) => {
  return axios.post('templates/packingslips', newTemplate);
};

export const putPackingSlipTemplate = (updatedTemplate) => {
  return axios.put(`templates/packingslips/${updatedTemplate.packingSlipId}`, updatedTemplate);
};

export const deletePackingSlipTemplate = (packingSlipId) => {
  return axios.delete(`templates/packingslips/${packingSlipId}`);
};

export const getTemplateHtmlContent = async (packingSlipId) => {
  const response = await axios.get(`templates/packingslips/html/${packingSlipId}`);
  return response.data;
};

/**
 * Get a PDF preview of a packing slip template
 * @param {object} template - The template data
 * @param {string} template.header - Header HTML
 * @param {string} template.itemsHeader - Items header HTML
 * @param {string} template.items - Items HTML
 * @param {string} template.footer - Footer HTML
 * @param {string} template.size - Template size
 * @returns {Promise<ArrayBuffer>} PDF file as ArrayBuffer
 */
export const getPackingSlipPreview = async (template) => {
  const response = await axios.post('templates/packingslips/template/preview', template, {
    responseType: 'arraybuffer',
  });
  return response.data;
};

const makeInput = (key, value) => {
  const input = document.createElement('input');
  input.name = key;
  input.value = value;
  return input;
};

export const downloadSamplePackingSlip = (storeGuid, template) => {
  const queryParams = new URLSearchParams();
  queryParams.append('storeGuid', storeGuid);
  const url = `/api/templates/packingslips/${template.packingSlipId}/download-sample?${queryParams}`;

  const form = document.createElement('form');
  form.method = 'post';
  form.action = url;
  const nameInput = makeInput('name', template.name);
  const headerInput = makeInput('header', template.header);
  const itemsHeaderInput = makeInput('itemsHeader', template.itemsHeader);
  const itemsInput = makeInput('items', template.items);
  const footerInput = makeInput('footer', template.footer);
  const sizeInput = makeInput('size', template.size);

  form.append(nameInput);
  form.append(headerInput);
  form.append(itemsHeaderInput);
  form.append(itemsInput);
  form.append(footerInput);
  form.append(sizeInput);

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);

  return new Promise((res) => {
    const interval = setInterval(() => {
      const isDownloaded = downloadCookieExists();
      if (isDownloaded) {
        removeDownloadCookie();
        clearInterval(interval);
        res();
      }
    }, 1000);
  });
};
